export const UserStatus = {
  EXPLORER: 'EXPLORER',
  VIVINAUT: 'VIVINAUT',
};

export const userStatus = [UserStatus.EXPLORER, UserStatus.VIVINAUT];
